import { Module } from 'vuex';
import { State as StateInterface } from '@/store/index';
import state, { PaymentStateInterface } from './state';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const PaymentModule: Module<PaymentStateInterface, StateInterface> = {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};

export default PaymentModule;
